/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AlbumManagementDetailAlbumRequest = {
  id?: number;
  groupId: number;
  perPage?: number | null;
  page?: number | null;
  keyword?: string | null;
  sort?: string | null;
  direction?: AlbumManagementDetailAlbumRequest.direction | null;
};

export namespace AlbumManagementDetailAlbumRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
